import React from 'react';
import { Button } from '@/components/ui/button';

// Build the list of page numbers to render, inserting '...' markers when the
// range is too wide. Always keeps the first, last and the current ±1 pages.
const buildPageItems = (current, totalPages) => {
  const pages = new Set([1, totalPages, current, current - 1, current + 1]);
  const sorted = [...pages]
    .filter((p) => p >= 1 && p <= totalPages)
    .sort((a, b) => a - b);

  const items = [];
  let prev = 0;
  for (const p of sorted) {
    if (prev && p - prev > 1) items.push(`ellipsis-${prev}`);
    items.push(p);
    prev = p;
  }
  return items;
};

// Numbered page selector. `page` is 0-indexed; `onPageChange` receives a
// 0-indexed page. Renders nothing unless there are more than 2 pages.
const Pagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 2) return null;

  const current = page + 1; // 1-indexed for display
  const items = buildPageItems(current, totalPages);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {items.map((item) =>
        typeof item === 'number' ? (
          <Button
            key={item}
            variant={item === current ? 'default' : 'outline'}
            size="sm"
            className="rounded-full min-w-9 px-3"
            aria-current={item === current ? 'page' : undefined}
            onClick={() => onPageChange(item - 1)}
          >
            {item}
          </Button>
        ) : (
          <span key={item} className="px-1 text-sm text-muted-foreground select-none">
            …
          </span>
        )
      )}
    </div>
  );
};

export default Pagination;
